// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage.js';
import QuadratPreprocessingPage from './QuadratPreprocessingPage.js'; // Updated import
import TimeSeriesPage from './TimeSeriesPage.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/prediction" element={<QuadratPreprocessingPage />} /> {/* Updated component */}
        <Route path="/timeseries" element={<TimeSeriesPage />} />
      </Routes>
    </Router>
  );
}

export default App;